import { __assign, __rest } from "tslib";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Lightning = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 11 14", fill: "currentColor", width: size || "11", height: size || "14" }, props),
        React.createElement("g", { id: "Typically-replies", stroke: "none", fill: "none", strokeWidth: "1", fillRule: "evenodd" },
            React.createElement("g", { id: "Typically-replies---Chat-w-Business-Content", transform: "translate(-137 -361)", fill: "currentColor", fillRule: "nonzero" },
                React.createElement("g", { id: "iconmonstr-connection-1-copy-6", transform: "translate(137 361)" },
                    React.createElement("path", { id: "Path", d: "M3.3 14L4.95 8.75 0 8.75 7.7 0 6.05 5.25 11 5.25z" }))))));
};
Lightning.displayName = 'Lightning';
export default Lightning;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Lightning.js.map